import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard({ showMessage, title }) {

    useEffect(() => {
            document.title = title;
        }, [title]);

    const navigate = useNavigate();

    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
                method: 'GET',
                credentials: "include",
            })
            .then(response => response.json())
            .then(data => {
                if (data.success !== 'true') {
                    navigate("/dashboard/login")
                }
            })
            .catch(error => {
                console.log(error)
            });
    }, []);

    const dashLogout = () =>{
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=removeUserSession', {
                method: 'GET',
                credentials: "include",
            })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success === 'true') {
                    showMessage("success", "Logged Out!");
                    navigate("/dashboard/login")
                }
            })
            .catch(error => {
                showMessage("error", "Something went wrong.");
        });
    }

    const dashRedirect = (pageNavigate) =>{
        navigate("/dashboard/" + pageNavigate)
    }


    return (
      <>
        <div className='dash_section'>
            <div className="dash_wrapper">

                <div className='dash_logout dash_logout_layout'>
                    <div className='dash_logout_cta' onClick={() => dashLogout()}>
                        Logout
                    </div>
                </div>


                <h1 className='dash_body_title'>
                    Dashboard
                </h1>
                
                <div className='dash_main_cards'>
                    <div className='dash_main_card' onClick={() => dashRedirect("editors")}>
                        Editors
                    </div>

                    <div className='dash_main_card' onClick={() => dashRedirect("reviewers")}>
                        Reviewers
                    </div>

                    <div className='dash_main_card' onClick={() => dashRedirect("announcements")}>
                        Announcements
                    </div>

                    <div className='dash_main_card' onClick={() => dashRedirect("issues")}>
                        Issues
                    </div>

                    <div className='dash_main_card' onClick={() => dashRedirect("articles")}>
                        Articles
                    </div>

                </div>
            </div>
        </div>
      </>
    );
}

export default Dashboard;